(function () {
  var MAX_ONLINE_QTY = 999999;

  function getMOQ(input) {
    var moq = parseInt(input.getAttribute('data-moq'), 10);
    return !isNaN(moq) && moq > 0 ? moq : 1;
  }

  function getQty(input) {
    var qty = parseInt(input.value, 10);
    return isNaN(qty) ? 0 : qty;
  }

  function isMOQInput(input) {
    return (
      input &&
      input.matches &&
      input.matches(
        '.js-cart-drawer-quantity-input[data-moq], .js-quantity-input[data-moq]'
      )
    );
  }

  function getQuantityInputFromButton(button) {
    var wrapper =
      button.closest('sht-cart-drwr-qty-inp') ||
      button.closest('sht-qty-inp');

    if (!wrapper) return null;

    return wrapper.querySelector(
      '.js-cart-drawer-quantity-input[data-moq], .js-quantity-input[data-moq]'
    );
  }

  function dispatchQuantityEvents(input) {
    input.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function createLargeOrderModal() {
    if (document.getElementById('largeOrderQuoteModal')) {
      return;
    }

    var modal = document.createElement('div');

    modal.id = 'largeOrderQuoteModal';

    modal.innerHTML = `
      <div class="large-order-modal__overlay"></div>

      <div
        class="large-order-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="largeOrderQuoteTitle"
      >
        <button
          type="button"
          class="large-order-modal__close"
          aria-label="Close"
        >
          ×
        </button>

        <h2 id="largeOrderQuoteTitle">
          Large Quantity Order
        </h2>

        <p>
          For orders of 1,000,000 units or more, please contact our sales team for a custom quote.
        </p>

        <p>
          Our team can provide volume pricing, production lead times, and shipping options for large orders.
        </p>

        <div class="large-order-modal__actions">
          <button
            type="button"
            class="large-order-modal__quote"
          >
            Request a Quote
          </button>

          <button
            type="button"
            class="large-order-modal__continue"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    `;

    var style = document.createElement('style');

    style.textContent = `
      #largeOrderQuoteModal {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 999999;
        align-items: center;
        justify-content: center;
        padding: 20px;
      }

      #largeOrderQuoteModal.is-open {
        display: flex;
      }

      .large-order-modal__overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.55);
      }

      .large-order-modal__dialog {
        position: relative;
        z-index: 1;
        width: 100%;
        max-width: 520px;
        background: #ffffff;
        color: #111111;
        border-radius: 16px;
        padding: 32px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
      }

      .large-order-modal__dialog h2 {
        margin: 0 0 16px;
        font-size: 28px;
        line-height: 1.2;
      }

      .large-order-modal__dialog p {
        margin: 0 0 14px;
        font-size: 15px;
        line-height: 1.6;
      }

      .large-order-modal__close {
        position: absolute;
        top: 14px;
        right: 16px;
        border: 0;
        background: transparent;
        font-size: 30px;
        line-height: 1;
        cursor: pointer;
      }

      .large-order-modal__actions {
        display: flex;
        gap: 12px;
        margin-top: 24px;
      }

      .large-order-modal__actions button {
        flex: 1;
        min-height: 48px;
        border-radius: 999px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
      }

      .large-order-modal__quote {
        border: 1px solid #111111;
        background: #111111;
        color: #ffffff;
      }

      .large-order-modal__continue {
        border: 1px solid #d7d7d7;
        background: #ffffff;
        color: #111111;
      }

      @media (max-width: 600px) {
        .large-order-modal__dialog {
          padding: 26px 20px 22px;
        }

        .large-order-modal__actions {
          flex-direction: column;
        }
      }
    `;

    document.head.appendChild(style);
    document.body.appendChild(modal);

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    modal
      .querySelector('.large-order-modal__close')
      .addEventListener('click', closeModal);

    modal
      .querySelector('.large-order-modal__continue')
      .addEventListener('click', closeModal);

    modal
      .querySelector('.large-order-modal__overlay')
      .addEventListener('click', closeModal);

    /*
     * Precise connection to the store's existing
     * Send Inquiry / Quote Cart page.
     */
    modal
      .querySelector('.large-order-modal__quote')
      .addEventListener('click', function () {
        window.location.href = '/pages/quote-cart';
      });

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          modal.classList.contains('is-open')
        ) {
          closeModal();
        }
      }
    );
  }

  function showLargeOrderModal() {
    createLargeOrderModal();

    var modal =
      document.getElementById(
        'largeOrderQuoteModal'
      );

    if (!modal) return;

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function enforceQuantityLimits(
    input,
    triggerChange
  ) {
    if (!isMOQInput(input)) return false;

    var moq = getMOQ(input);
    var qty = getQty(input);
    var changed = false;

    /*
     * Quantity 0 may temporarily be used
     * while removing an item.
     */
    if (qty <= 0) {
      return false;
    }

    /*
     * Minimum quantity protection.
     */
    if (qty < moq) {
      input.value = moq;
      changed = true;
    }

    /*
     * Maximum online quantity protection.
     */
    if (qty > MAX_ONLINE_QTY) {
      input.value = MAX_ONLINE_QTY;
      changed = true;

      showLargeOrderModal();
    }

    if (changed && triggerChange) {
      dispatchQuantityEvents(input);
    }

    return changed;
  }

  function syncQuantityComponent(input) {
    if (!isMOQInput(input)) return;

    var wrapper =
      input.closest('sht-cart-drwr-qty-inp') ||
      input.closest('sht-qty-inp');

    if (!wrapper) return;

    var moq = getMOQ(input);
    var qty = getQty(input);

    var minusButton = wrapper.querySelector(
      '[name="minus"], .js-cart-drawer-quantity-btn-minus, .js-quantity-btn-minus'
    );

    var plusButton = wrapper.querySelector(
      '[name="plus"], .js-cart-drawer-quantity-btn-plus, .js-quantity-btn-plus'
    );

    /*
     * Minus is usable only above MOQ.
     */
    if (minusButton) {
      if (qty > moq) {
        minusButton.disabled = false;
        minusButton.removeAttribute(
          'disabled'
        );
        minusButton.removeAttribute(
          'aria-disabled'
        );
      }
    }

    /*
     * Plus is usable until the online maximum.
     */
    if (plusButton) {
      if (qty < MAX_ONLINE_QTY) {
        plusButton.disabled = false;

        plusButton.removeAttribute(
          'disabled'
        );

        plusButton.removeAttribute(
          'aria-disabled'
        );
      } else {
        plusButton.disabled = true;

        plusButton.setAttribute(
          'disabled',
          ''
        );

        plusButton.setAttribute(
          'aria-disabled',
          'true'
        );
      }
    }

    /*
     * Refresh Blum quantity component state.
     */
    input.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  }

  function scanCartForInvalidQuantity(
    triggerChange
  ) {
    var inputs = document.querySelectorAll(
      '.js-cart-drawer-quantity-input[data-moq], .js-quantity-input[data-moq]'
    );

    inputs.forEach(function (input) {
      enforceQuantityLimits(
        input,
        triggerChange
      );
    });
  }

  function syncAllQuantityComponents() {
    var inputs = document.querySelectorAll(
      '.js-cart-drawer-quantity-input[data-moq], .js-quantity-input[data-moq]'
    );

    inputs.forEach(function (input) {
      syncQuantityComponent(input);
    });
  }

  function getInvalidQuantityInputs() {
    var inputs = document.querySelectorAll(
      '.js-cart-drawer-quantity-input[data-moq], .js-quantity-input[data-moq]'
    );

    return Array.from(inputs).filter(
      function (input) {
        var qty = getQty(input);
        var moq = getMOQ(input);

        return (
          qty > 0 &&
          (
            qty < moq ||
            qty > MAX_ONLINE_QTY
          )
        );
      }
    );
  }

  function initCartMOQ() {
    createLargeOrderModal();

    /*
     * 1. Minus button protection.
     */
    document.addEventListener(
      'click',
      function (event) {
        var minusButton =
          event.target.closest(
            '.js-cart-drawer-quantity-btn-minus, .js-quantity-btn-minus, [name="minus"]'
          );

        if (!minusButton) return;

        var input =
          getQuantityInputFromButton(
            minusButton
          );

        if (!input) return;

        var moq = getMOQ(input);
        var qty = getQty(input);

        if (qty <= moq) {
          event.preventDefault();
          event.stopImmediatePropagation();

          input.value = moq;

          syncQuantityComponent(input);
        }
      },
      true
    );

    /*
     * 2. Plus button maximum protection.
     */
    document.addEventListener(
      'click',
      function (event) {
        var plusButton =
          event.target.closest(
            '.js-cart-drawer-quantity-btn-plus, .js-quantity-btn-plus, [name="plus"]'
          );

        if (!plusButton) return;

        var input =
          getQuantityInputFromButton(
            plusButton
          );

        if (!input) return;

        var qty = getQty(input);

        if (qty >= MAX_ONLINE_QTY) {
          event.preventDefault();
          event.stopImmediatePropagation();

          input.value =
            MAX_ONLINE_QTY;

          showLargeOrderModal();
          syncQuantityComponent(input);

          return;
        }

        syncQuantityComponent(input);
      },
      true
    );

    /*
     * 3. Manual quantity change.
     */
    document.addEventListener(
      'change',
      function (event) {
        var input = event.target;

        if (!isMOQInput(input)) return;

        if (
          enforceQuantityLimits(
            input,
            false
          )
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();

          dispatchQuantityEvents(input);

          return;
        }

        syncQuantityComponent(input);
      },
      true
    );

    /*
     * 4. Protection while typing.
     */
    document.addEventListener(
      'input',
      function (event) {
        var input = event.target;

        if (!isMOQInput(input)) return;

        var qty = getQty(input);

        if (qty > MAX_ONLINE_QTY) {
          input.value =
            MAX_ONLINE_QTY;

          showLargeOrderModal();
        }
      },
      true
    );

    /*
     * 5. Blur validation.
     */
    document.addEventListener(
      'blur',
      function (event) {
        var input = event.target;

        if (!isMOQInput(input)) return;

        if (
          !enforceQuantityLimits(
            input,
            true
          )
        ) {
          syncQuantityComponent(input);
        }
      },
      true
    );

    /*
     * 6. Checkout final protection.
     */
    document.addEventListener(
      'click',
      function (event) {
        var checkoutButton =
          event.target.closest(
            'button[name="checkout"], input[name="checkout"], .js-cart-drawer-submit-btn'
          );

        if (!checkoutButton) return;

        var invalidInputs =
          getInvalidQuantityInputs();

        if (!invalidInputs.length) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        invalidInputs.forEach(
          function (input) {
            enforceQuantityLimits(
              input,
              true
            );

            syncQuantityComponent(
              input
            );
          }
        );

        var firstInvalid =
          invalidInputs[0];

        if (firstInvalid) {
          firstInvalid.focus();

          firstInvalid.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      },
      true
    );

    /*
     * 7. AJAX / third-party recovery.
     */
    var scanTimer = null;

    var observer =
      new MutationObserver(function () {
        clearTimeout(scanTimer);

        scanTimer = setTimeout(
          function () {
            scanCartForInvalidQuantity(
              true
            );

            syncAllQuantityComponents();
          },
          150
        );
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    /*
     * Initial scan.
     */
    scanCartForInvalidQuantity(true);

    setTimeout(function () {
      syncAllQuantityComponents();
    }, 150);

    /*
     * Browser back/forward cache recovery.
     */
    window.addEventListener(
      'pageshow',
      function () {
        setTimeout(function () {
          scanCartForInvalidQuantity(
            true
          );

          syncAllQuantityComponents();
        }, 150);
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initCartMOQ
    );
  } else {
    initCartMOQ();
  }
})();